export const NO_UPDATE_MESSAGE = 'No Updates.';

const NO_UPDATE_PATTERN = /^no updates\.?$/i;
const NETWORK_MESSAGE_PATTERN = /^network(\s+error)?$/i;

/**
 * True when an API returned an empty-state error, not a real failure.
 * Accepts a message string or common API error payload shapes.
 */
export const isNoUpdateError = (value) => {
    if (value == null) return false;

    if (typeof value === 'string') {
        return NO_UPDATE_PATTERN.test(value.trim());
    }

    const message =
        value?.error ||
        value?.message ||
        value?.response?.data?.error ||
        value?.response?.data?.message;

    if (typeof message !== 'string') return false;
    return NO_UPDATE_PATTERN.test(message.trim());
};

/**
 * True for connectivity failures where no HTTP response was received.
 * Accepts axios-style error objects or message strings.
 */
export const isNetworkError = (value) => {
    if (value == null) return false;

    if (typeof value === 'object') {
        if (value.response) return false;

        const code = value.code;
        if (code === 'ERR_NETWORK' || code === 'ECONNABORTED') return true;

        const message = value.message;
        if (typeof message === 'string') {
            const trimmed = message.trim();
            if (NETWORK_MESSAGE_PATTERN.test(trimmed)) return true;
            if (trimmed.toLowerCase().startsWith('network')) return true;
        }

        return false;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (NETWORK_MESSAGE_PATTERN.test(trimmed)) return true;
        if (trimmed.toLowerCase().startsWith('network')) return true;
    }

    return false;
};

/** Errors that should not open the global error modal. */
export const shouldSuppressErrorModal = (value) =>
    isNoUpdateError(value) || isNetworkError(value);
